import clsx from "clsx";
import shape from "../../assets/img/shapes/line-shape-03.webp";


const LineShape03 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-line-shape-03", props.className)}>
            <img src={shape} alt="rmdr-line-shape-03" loading="lazy" width={270} height={350} />
        </div>
    )

}

export default LineShape03;
